//SignIn_Auth0.ts =================================================
// Website: https://auth0.com/
// Code Examples: https://auth0.com/docs/libraries/auth0-single-page-app-sdk#create-the-client
// 1) a) Create a new "Single Page Web Application" call it "GIS Website" or whatever

//    b) Set Settings -> "Allowed Callback URLs" to:
//       https:// Your WEBSERVER URL/, https:// Your WEBSERVER URL/YourWebsiteNameTS/, http://localhost:1337/ (for VS)
//       Note - The trailing slash should be entered and its case sensitive.

//    c) Set "Allowed Logout URLs" to https:// Your WEBSERVER URL/YourWebsiteNameTS/, http://localhost:1337/ (for VS)
//       Note - The trailing slash is required and its case sensitive.

//    d) Set "Allowed Web Origins" to https://Your WEBSERVER URL/, http://localhost:1337/
//       Note - The trailing slash is required and its case sensitive.

//    e) Refresh Token Rotation - Enable it.  Also verify under Advanced Settings -> Grant Types that Refresh Token is checked on.

//    f) Save Changes

// 2) Authentication->Database->Username-Password-Authentication->Disable sign ups

// 3) Branding->Universal login->Settings: Upload logo and set colors if desired. Save changes.
//    Settings->General: To set the friendly name of your domain.

// 4) Applications->Applications->GIS Website->Settings->Copy "Domain" and "Client ID" into Settings.ts

// 5) a) User Management->Users->Create User->Enter Email and Password
//    b) Edit the "Name" to be more readable and to set the security access level. Example: 7 ! Joe Bloe
//    c) Repeat for each new user
//    d) Have each user verify their new Auth0 login in their email.

import * as Settings from "../Settings";
import * as Util from "./Util";

import { createAuth0Client, Auth0Client } from '@auth0/auth0-spa-js';

export let signedIn: boolean = false;
export let email: string = "";
export let userName: string = "";
export let accessLevel: number = 0;

let auth0_client: Auth0Client;

//Declare the callback function.
interface iCallbacks {
   success(): void;
   fail(): void;
}
let callback: iCallbacks;

export function authenticate(callbacks: iCallbacks) {
   Util.logMsg("Auth0: Creating API.");
   callback = callbacks;

   createAuth0Client({
      domain: Settings.auth0_domain,
      clientId: Settings.auth0_clientId,
      useRefreshTokens: true, //Required to bypass 3rd party cookie blocking.
      cacheLocation: "localstorage" //Required so user does not have to click the sign-in button if signed in previously.
      //authorizationParams: { audience: "https://" + Settings.auth0_domain + "/api/v2/", scope: "openid profile email offline_access" },

   }).then(auth0Client => {
      auth0_client = auth0Client;
      Util.logMsg("Created API - auth0_client", auth0_client);

      auth0_client.isAuthenticated().then(authenticated => {
         Util.logMsg("Authenticated true/false", authenticated);

         if (authenticated) {
            Util.logMsg("Yeppers, it is authenticated");

            //logged in. Get the user profile:
            auth0_client.getUser().then(user => {
               Util.logMsg("Login: Getting Auth0 user information: ", user);

               if (user) {
                  signedIn = true;
                  email = user.email;
                  userName = user.nickname; // Prefix portion of the users email address.
                  accessLevel = Util.parseInteger(user.name); //Access level comes from the edited "Name" in Auth0.  Example: 9 ! Joe Bloe
                  if (accessLevel === 0) {
                     accessLevel = 1; //Default for at least having an auth0 account.
                  }
                  callback.success();

               } else {
                  callback.fail();
               }
            });

         } else {
            Util.logMsg("Nope, Not authenticated");
            callback.fail();
         }

      }).catch((error: Error) => {
         Util.errMsg("isAuthenticated failed: ", error);
         callback.fail();
      });

   }).catch((error: Error) => {
      Util.errMsg("createAuth0Client failed: ", error);
      callback.fail();
   });
}

//Sign in. 
export function signIn() {
   auth0_client.loginWithPopup({}).then(() => {
      Util.logMsg("signIn: Successfully logged in");
      auth0_client.loginWithRedirect({ authorizationParams: { redirect_uri: window.location.href } });

   }).catch((error: Error) => {
      Util.logMsg("Gracefully closing the login popup");
   });
}

//Sign out.
export function signOut() {
   Util.logMsg("Auth0: logging out.");
   auth0_client.logout({
      logoutParams: { returnTo: window.location.href } // return URL parameter is required.
   });
}
